import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import navigation_hintButtonSectionView from "../../../../layout/navigation/components/hint/section-view";
import {UIType} from "../../../../layout/ui/@const";


export class SpaceQuickAdd extends SpaceProto {

    constructor() {
        super(NavigationSectionType.QUICK_ADD)

        this.title              = "Add"
        this.svgIcon            = "isvg-add"
        this.icon               = "i5-nav-add"


        switch (gd.ui.type) {


            case UIType.ASANA:
                this.positions = []
                break

            case UIType.TEAMS:
            default:
                this.defaultPosition    = NavigationButtonPosition.TOP
                break

        }



    }

    get position() {
        // patch
        if (gd.ui.type === UIType.ASANA) {
            return NavigationButtonPosition.STATIC
        }

        return super.position
    }

    set position(position: NavigationButtonPosition) {
        super.position = position
    }

    onClick = () => {
        gd.openNew()
    }

    // getDisplayOptions():Options {
    //
    //     // patch
    //     if (gd.ui.type === UIType.ASANA) {
    //         return []
    //     }
    //
    //     return [
    //         OptionNavigationPanelTop,
    //         OptionNavigationPanelMore
    //     ]
    //
    // }

    get navigationStructureConfig() {

        return {
            id              : NavigationSectionType.QUICK_ADD,
            icon            : this.icon, //fs-20
            iconSettings    : this.icon,
            hint            : gd.ui.quickAddLabel,
            type            : NavigationSectionType.QUICK_ADD,
            keyboardShortcut: 'N',
            renderComponent : Navigation_ButtonGenericDeprecated,
            onClick         : this.onClick,
            position        : this.position,
            hintButtons     : navigation_hintButtonSectionView,
        }

    }



}
